import PaginationCount from './PaginationCount';

export default PaginationCount;
